import VueRouter from 'vue-router';

class AppRouter extends VueRouter {
  push(to) {
    if (this.currentRoute && this.currentRoute.name === to.name) {
      return;
    }

    super.push(to);
  }
}

export default AppRouter;